/**
 * Step 7 tracked-change reviewer label.
 *
 * Display-only. Does not affect approval, matching, or apply eligibility.
 * Uses Word w:author strings already present on the change object — never
 * people.xml / account IDs.
 */

export interface TrackedChangeAttributionSource {
  source_signal?: string | null;
  author?: string | null;
  authors?: string[] | null;
}

function distinctAuthors(change: TrackedChangeAttributionSource): string[] {
  const out: string[] = [];
  for (const value of [...(change.authors || []), change.author]) {
    const name = String(value || '').trim();
    if (!name) continue;
    if (!out.includes(name)) out.push(name);
  }
  return out;
}

function joinAuthorNames(names: string[]): string {
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

export function isTrackedChangeSource(change: TrackedChangeAttributionSource): boolean {
  return change.source_signal === 'tracked_change';
}

export function trackedChangeAttributionLabel(
  change: TrackedChangeAttributionSource
): string | null {
  if (!isTrackedChangeSource(change)) return null;
  const names = distinctAuthors(change);
  if (names.length === 0) return 'Reviewer not available';
  return `Tracked change by ${joinAuthorNames(names)}`;
}
